"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCaptureMethod = void 0;
var StripeCaptureMethod;
(function (StripeCaptureMethod) {
    StripeCaptureMethod["Manual"] = "manual";
    StripeCaptureMethod["Automatic"] = "automatic";
})(StripeCaptureMethod || (exports.StripeCaptureMethod = StripeCaptureMethod = {}));
//# sourceMappingURL=StripeCaptureMethod.js.map